export default {
  name: 'Phone Number',
  edit: {
    form: 'telephone-input',
    label: 'Edit the Phone Number',
    handler: value => value,
  },
};
